import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'degerlendirme-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--deger" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">DEĞERLENDİRME</div>
        <div class="gc-stat-bolge">
          <div class="gc-stat-satir">
            <div class="gc-stat-ikon gc-stat-ikon--yesil"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg></div>
            <div class="gc-stat-isim">KALİTE</div>
            <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu gc-stat-bar--yesil" [style.width.%]="gorunur() ? (p()?.kalitePuani||3)*20 : 0"></div></div>
            <div class="gc-stat-deger gc-stat-deger--yesil">{{ p()?.kalitePuani || 3 }}</div>
          </div>
          <div class="gc-stat-satir">
            <div class="gc-stat-ikon gc-stat-ikon--cyan"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></div>
            <div class="gc-stat-isim">TESLİMAT</div>
            <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu gc-stat-bar--cyan" [style.width.%]="gorunur() ? (p()?.teslimatPuani||3)*20 : 0"></div></div>
            <div class="gc-stat-deger gc-stat-deger--cyan">{{ p()?.teslimatPuani || 3 }}</div>
          </div>
          <div class="gc-stat-satir">
            <div class="gc-stat-ikon gc-stat-ikon--turuncu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg></div>
            <div class="gc-stat-isim">FİYAT</div>
            <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu gc-stat-bar--turuncu" [style.width.%]="gorunur() ? (p()?.fiyatPuani||3)*20 : 0"></div></div>
            <div class="gc-stat-deger gc-stat-deger--turuncu">{{ p()?.fiyatPuani || 3 }}</div>
          </div>
        </div>
        @if (p()?.notlar) { <div class="dg-notlar">{{ p().notlar }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? ortalama()*20 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #b45309; --accent-rgb: 180,83,9; }
    .dg-notlar { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 4px; }
  `],
})
export class DegerlendirmeKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  ortalama = computed(() => {
    const d = this.p();
    return Math.round(((d?.kalitePuani || 3) + (d?.teslimatPuani || 3) + (d?.fiyatPuani || 3)) / 3);
  });
}
